import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Combobox } from '@salesforce/design-system-react';

class CollaboratorsComboBox extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    inputValue: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      labels: {
        label: 'Search Users by Email',
        placeholder: 'Search for Users to Collaborate with by Email...',
      },
      selection: [],
    };
  }

  onChange = (event, { value }) => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  onRemove = (event, data) => {
    // clear the input search
    this.props.onChange('');
    this.setState({
      selection: data.selection,
    });

    this.props.setCollaborators(this.state.selection);
  };

  onSubmit = (event, { value }) => {};

  onSelect = (event, data) => {
    if (this.props.onSelect) {
      this.props.onSelect(event, ...Object.keys(data).map((key) => data[key]));
    }
    // clear the input search
    this.props.onChange('');
    this.setState({ selection: data.selection });

    let collabEmails = [];
    for (let i = 0; i < data.selection.length; i++) {
      collabEmails.push(data.selection[i].subTitle);
    }

    this.props.setCollaborators(collabEmails);
  };

  render() {
    return (
      <Combobox
        id="combobox-inline-single"
        events={{
          onChange: this.onChange,
          onRequestRemoveSelectedOption: this.onRemove,
          onSubmit: this.onSubmit,
          onSelect: this.onSelect,
        }}
        multiple
        hasStaticAlignment
        menuPosition="relative"
        variant="inline-listbox"
        selection={this.state.selection}
        value={this.props.inputValue}
        labels={this.state.labels}
        hasMenuSpinner={this.props.isLoading}
        options={this.props.options}
      />
    );
  }
}
export default CollaboratorsComboBox;
